import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'src/lib/i18n-react'

import UpdateBrowserProvider from './subcomponents/UpdateBrowserProvider/UpdateBrowserProvider'
import HomeSkeleton from './HomeSkeleton'

const Home = ({
  nextActivitySection,
  tutoringAppointmentSection,
  goalsSection,
  recommendedActivitiesSection,
  nudgeCardSection,
}) => {
  return (
    <>
      <HomeSkeleton
        headerSection={t('Home')}
        nudgeCardSection={nudgeCardSection}
        goalsSection={goalsSection}
        tutoringAppointmentSection={tutoringAppointmentSection}
        nextActivitySection={nextActivitySection}
        recommendedActivitiesSection={recommendedActivitiesSection}
      />
      <UpdateBrowserProvider />
    </>
  )
}

Home.propTypes = {
  nextActivitySection: PropTypes.any,
  tutoringAppointmentSection: PropTypes.any,
  goalsSection: PropTypes.any,
  recommendedActivitiesSection: PropTypes.any,
  nudgeCardSection: PropTypes.any,
}

export default Home
